import isEmail from 'validator/es/lib/isEmail'

export const parseEmails = str => (str || '').replace(/\n/g, ',').split(',').map(e => e.replace(/\s+/g, '')).filter(Boolean)

export const normalizeEmails = str => parseEmails(str).join(', ')

export const validateEmails = str => {
	const emails = parseEmails(str)
	return emails.length > 0 && emails.every(e => isEmail(e))
}
